import { v4 as uuid4 } from 'uuid';

export function getAppId() {
    return `${CONFIG.league}_${CONFIG.tricode}`.toUpperCase();
}

export function getInstallId() {
    let id = window.localStorage.getItem('LoyaltyInstallId');
    if (!id) {
        id = uuid4();
        window.localStorage.setItem('LoyaltyInstallId', id);
    }
    return id;
}
